module.exports = __webpack_public_path__ + "media/images/hero/glyph-b1-5c4cb52978d82fb38df7ef824e7647ce.svg";